var classes = {"day":"H0seq"};

export { classes as default };
